import { render, staticRenderFns } from "./railway-control-card-way-control.vue?vue&type=template&id=731c338e"
import script from "./railway-control-card-way-control.vue?vue&type=script&lang=js"
export * from "./railway-control-card-way-control.vue?vue&type=script&lang=js"
import style0 from "./railway-control-card-way-control.vue?vue&type=style&index=0&id=731c338e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./railway-control-card-way-control.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports